import { render, staticRenderFns } from "./WhatsappTable.vue?vue&type=template&id=78bde448&scoped=true&"
import script from "./WhatsappTable.vue?vue&type=script&lang=js&"
export * from "./WhatsappTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bde448",
  null
  
)

export default component.exports